// polyfills for IE11
import 'babel-polyfill'; //eslint-disable
import 'whatwg-fetch'; //eslint-disable

import { TenupInit } from './10up/index';
import { BSD } from './bsd/index';

TenupInit();

BSD();
